import Chip from "@mui/material/Chip"
import Tooltip from "@mui/material/Tooltip"

import { ReactComponent as DragParentColor } from "../../assets/images/drag_parent_color.svg"
import { ReactComponent as TagIcon } from "../../assets/images/tag.svg"

type Props = {
    label: string
    bgColor?: string
    textColor?: string
    onDelete?: () => void
    draggable?: boolean
    onDragStart?: (event: React.DragEvent<HTMLDivElement>) => void
    tagAccess: any
}

// Helper to lighten a hex color by a given amount (0 to 1)
function lightenColor(hexColor: string, amount = 0.95) {
    if (!hexColor) return hexColor

    let col = hexColor.startsWith("#") ? hexColor.substring(1) : hexColor

    // Handle short form like "abc"
    if (col.length === 3) {
        col = col
            .split("")
            .map(c => c + c)
            .join("")
    }

    const num = parseInt(col, 16)
    let r = (num >> 16) & 0xff
    let g = (num >> 8) & 0xff
    let b = num & 0xff

    r = Math.round(r + (255 - r) * amount)
    g = Math.round(g + (255 - g) * amount)
    b = Math.round(b + (255 - b) * amount)

    return `rgb(${r}, ${g}, ${b})`
}
export function CloseCircleFilled(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="8" cy="8" r="8" fill="currentColor" />
            <path d="M5 5L11 11M11 5L5 11" stroke="white" strokeWidth="2" strokeLinecap="round" />
        </svg>
    )
}

const TagChip = (props: Props) => {
    const lightBg = props.bgColor ? lightenColor(props.bgColor, 0.85) : undefined

    return (
        <Tooltip enterDelay={1000} title={props.label}>
            <Chip
                label={props.label}
                draggable={props.draggable}
                icon={props.draggable ? <DragParentColor /> : <TagIcon />}
                onDragStart={props.onDragStart}
                onClick={() => {}}
                className="d-flex align-items-center"
                sx={{
                    backgroundColor: lightBg,
                    color: props.bgColor,
                    maxWidth: 225,
                    width: "fit-content",
                    height: 22,
                    borderRadius: 12,
                    fontSize: 12,
                    fontWeight: 500,
                    lineHeight: "18px",
                    padding: "0 8px 0 2px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",

                    "& .MuiChip-deleteIcon": {
                        color: props.bgColor,
                        width: 12,
                        height: 12,
                        minWidth: 12,
                        minHeight: 12,
                        flexShrink: 0,
                    },
                    "& .MuiChip-icon": {
                        color: props.bgColor,
                        height: 12,
                        width: 12,
                        flexShrink: 0,
                    },
                }}
                {...(props.draggable && props?.tagAccess?.deleteTagIdAccess
                    ? {
                          deleteIcon: <CloseCircleFilled />,
                          onDelete: () => {
                              props.onDelete?.()
                          },
                      }
                    : {})}
            />
        </Tooltip>
    )
}

export default TagChip
